/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './index.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const composeClasses = (className) => className ?
    `labeled-node ${className}` :
    'labeled-node';

const LabeledNode = (props) => (
    <div className={composeClasses(props.className)}>
        <span className="data-label">
            <FormattedMessage id={props.label} />
        </span>
        <span className="data-node">{props.data}</span>
    </div>
);

LabeledNode.displayName = 'LabeledNode';
LabeledNode.propTypes = {
    className: PropTypes.string,
    data: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
};

export default LabeledNode;
